import { GetStaticProps } from 'next'
import React from 'react'

import Page from '@aletheia/common/components/Page'

import { OurFunds } from '../../components/Home'
import { fetchFunds, IFund } from '../../contentful'

type FundsProps = {
  Funds: IFund[]
}

const FundsPage: React.FC<FundsProps> = ({ Funds }) => {
  return (
    <Page
      title="Effective Altruism Funds"
      variant="full"
      showTitle={false}
      showPageTitle={false}
    >
      <OurFunds Funds={Funds} />
    </Page>
  )
}

export const getStaticProps: GetStaticProps<FundsProps> = async () => {
  const [Funds] = await Promise.all([fetchFunds()])

  return {
    props: {
      Funds,
    },
    revalidate: 20,
  }
}

export default FundsPage
